import { useState, useCallback } from "react";

export function useNotification(timeout = 3000) {
  const [notification, setNotification] = useState("");
  const showNotification = useCallback(
    (msg) => {
      setNotification(msg);
      setTimeout(() => setNotification(""), timeout);
    },
    [timeout],
  );
  return { notification, setNotification, showNotification };
}
